import { addVoucher, updateVoucher, getId } from "../../src/services/voucher";
import * as voucherServices from "../../src/services/voucher";
import pick from "lodash/pick";
import omit from "lodash/omit";
import get from "lodash/get";
import moment from "moment";
import { message } from "antd";
import { fromMinutes } from "../utils/utils";

const RESOURCE = "vouchers";
const transfromDocument = (record) => {
  // if (record.start_at) {
  //   const startAt = record.start_at;
  //   record.start_at = moment(startAt);
  // }
  // if (record.end_at) {
  //   const endAt = record.end_at;
  //   record.end_at = moment(endAt);
  // }

  if (record.created) {
    const createdAt = record.created;
    record.created = moment.unix(createdAt);
  }
  if (record.updatedAt) {
    const updatedAt = record.updatedAt;
    record.updatedAt = moment(updatedAt);
  }
  if (record.start_at) {
    const startAt = record.start_at;
    record.start_at = moment.unix(startAt);
  }
  if (record.end_at) {
    const endAt = record.end_at;
    record.end_at = moment.unix(endAt);
  }
  if (record.code_expired_at) {
    const code_expired_at = record.code_expired_at;
    record.code_expired_at = moment.unix(code_expired_at * 86400);
  }
  if (record.partner_id && record.partner) {
    record.partner_id = record.partner;
  }
  if (record.store_ids && record.stores) {
    record.store_ids = record.stores;
  }
  if (record.during_day_start) {
    record.during_day_start = fromMinutes(record.during_day_start);
  }
  if (record.during_day_end) {
    record.during_day_end = fromMinutes(record.during_day_end);
  }
  if (record.code_expired_duration) {
    record.code_expired_duration = record.code_expired_duration / 86400;
  }
  if (record.autocheckout === 1) {
    record.autocheckout = true;
  } else {
    record.autocheckout = false;
  }
  if (record.images) {
    record.images =
      record.images && record.images.length > 0
        ? record.images
          .filter((i) => i && i !== "")
          .map((i, idx) => ({
            uid: `${record.id}${idx + 1}`,
            name: `${record.name}-${idx}` || "",
            status: "done",
            url: i,
          }))
        : "";
  }
  if (record.thumb && Array.isArray(record.thumb)) {
    record.thumb =
      record.thumb && record.thumb.length > 0
        ? record.thumb
          .filter((i) => i && i !== "")
          .map((i, idx) => ({
            uid: `${record.id}${idx + 1}`,
            name: `${record.name}-${idx}` || "",
            status: "done",
            url: i,
          }))
        : [];
  } else if (record.thumb && typeof record.thumb === "string") {
    record.thumb = [
      {
        uid: `${record.id}`,
        name: `${record.name}` || "",
        status: "done",
        url: record.thumb,
      },
    ];
  }

  return record;
};

const getTableChange = () => {
  if (sessionStorage.getItem("tableChange"))
    return JSON.parse(sessionStorage.getItem("tableChange"));
  return null;
};

export default {
  namespace: "vouchers",

  state: {
    data: {
      list: [],
      pagination: {
        anchor: "",
        listAnchor: {
          1: "",
        },
      },
    },
    submitting: false,
    formTitle: "",
    formID: "",
    formVisible: false,
    formData: {},
    tableChange: getTableChange() || {
      pagination: {},
      filtersArg: {},
      sorter: {}
    }
  },

  effects: {
    *fetch({ payload, callback }, { call, put }) {
      let list = [];
      try {
        const response = yield call(voucherServices.getList, payload);
        if (response) {
          if (response.vouchers) {
            list = response.vouchers.map((item) => {
              transfromDocument(item);
              return item;
            });
          }
          yield put({
            type: "save",
            payload: {
              list,
              pagination: {
                total: response.total,
                anchor: get(response, ["anchor"], ""),
                listAnchor: {
                  [((payload && payload.current) || 1) + 1]: get(
                    response,
                    ["anchor"],
                    ""
                  ),
                },
              },
            },
          });
        }
      } catch (error) {
        console.log("*fetch -> error", error);
      }
      if (callback) {
        callback(list);
      }
    },
    *loadForm({ payload, callback }, { put }) {
      console.log("loadForm -> payload: ", payload);
      yield put({
        type: "changeFormVisible",
        payload: true,
      });

      yield [
        put({
          type: "saveFormType",
          payload: payload.type,
        }),
        put({
          type: "saveFormTitle",
          payload: "Tạo mới voucher",
        }),
        put({
          type: "saveFormID",
          payload: "",
        }),
        put({
          type: "saveFormData",
          payload: {
            get_code_method: "random",
            ...(payload.record || {})
          },
        }),
      ];
      if (payload.type === "E") {
        yield [
          put({
            type: "saveFormTitle",
            payload: "Chỉnh sửa voucher",
          }),
          put({
            type: "saveFormID",
            payload: payload.id,
          }),
          put({
            type: "fetchForm",
            payload: {
              id: payload.id,
            },
          }),
        ];
      } else if (payload.type === "SYNC_ONE_PARTNER") {
        yield [
          put({
            type: "saveFormTitle",
            payload: "Đồng bộ một đối tác",
          }),
          put({
            type: "saveFormID",
            payload: payload.id,
          }),
          // put({
          //   type: 'fetchPartner',
          //   payload: {
          //     id: payload.item
          //   },
          // }),
        ];
      }
      if (callback) {
        callback();
      }
    },
    *fetchForm({ payload, callback }, { call, put }) {
      let response;
      try {
        payload = Object.assign(payload, { includes: "partner,stores" });
        response = yield call(voucherServices.get, payload.id, payload);
        if (response) transfromDocument(response);
        yield [
          put({
            type: "saveFormData",
            payload: response,
          }),
        ];
      } catch (error) {
        console.log("*fetch -> error", error);
      }
      if (callback) {
        callback(response);
      }
    },

    *syncAllPartner({ payload, callback }, { call, put }) {
      console.log("syncAllPartner -> payload: ", payload);
      let success = false;
      if (payload.type === "SYNC_ALL_PARTNER") {
        const response = yield call(
          voucherServices.syncAll,
          payload,
          payload.id
        );
        console.log("syncAllPartner -> response: ", response);
        if (response === null) {
          success = true;
        }
      }
      if (success === false) {
        message.error("Đồng bộ thất bại");
      } else {
        message.success("Đồng bộ thành công");
      }

      // yield put({
      //   type: 'saveFormData',
      //   payload: response
      // });
    },
    *syncOnePartner({ payload, callback }, { call, put }) {
      console.log("syncOnePartner -> payload: ", payload);
      let success = false;
      if (payload.type === "SYNC_ONE_PARTNER") {
        const response = yield call(
          voucherServices.syncOne,
          payload,
          payload.id,
          payload.partner_id
        );
        console.log("syncOnePartner -> response: ", response);
        if (response === null) {
          success = true;
        }
      }
      if (success === false) {
        message.error("Đồng bộ thất bại");
      } else {
        message.success("Đồng bộ thành công");
      }
    },

    *submit({ payload, callback }, { call, put, select }) {
      try {
        yield put({
          type: "changeSubmitting",
          payload: true,
        });

        const params = { ...payload };
        const formType = yield select((state) => state.vouchers.formType);
        console.log("*submit -> formType", formType);

        let success = false;
        if (formType === "E") {
          const id = yield select((state) => state.vouchers.formID);
          console.log("*submit -> id", id);
          const response = yield call(voucherServices.update, params, id);
          console.log("*submit -> response", response);
          if (response === null) {
            success = true;
          }
        }
        if (formType === "A") {
          //console.log('*submit -> params', params, formType);
          const response = yield call(voucherServices.create, params);
          console.log("*submit -> response", response);
          if (response === null) {
            success = true;
          }
        }

        yield put({
          type: "changeSubmitting",
          payload: false,
        });

        if (success === true) {
          if (formType === "E") {
            message.success("Sửa thành công");
            yield put({
              type: "changeFormVisible",
              payload: false,
            });
          } else {
            message.success("Thêm mới thành công");
            yield put({
              type: "changeFormVisible",
              payload: false,
            });
          }

          if (callback && success) {
            callback();
          }
        } else {
          message.error("Thao tác thất bại");
        }
      } catch (error) {
        message.error("Thao tác thất bại");
      }
    },
    *updateState({ payload, callback }, { call, put, select }) {
      const params = { ...payload };
      let id = params.id;
      try {
        const response = yield call(voucherServices.update, params, id);
        if (response === null) {
          message.success("Thay đổi trạng thái thành công");
        } else {
          message.error("Thay đổi trạng thái thất bại");
        }
      } catch (error) { }

      callback();
    },
    *tableChange({ payload, callback }, { call, put }) {

      console.log(`🚀 ~ file: vouchers.js ~ line 385 ~ *tableChange ~ getTableChange`, getTableChange());
      yield put({
        type: "saveTableChange",
        payload,
      });
      sessionStorage.setItem("tableChange", JSON.stringify(payload));
    }
  },

  reducers: {
    save(state, action) {
      return {
        ...state,
        data: {
          ...state.data,
          list: action.payload.list,
          pagination: {
            ...state.data.pagination,
            anchor: action.payload.pagination.anchor,
            total: action.payload.pagination.total,
            listAnchor: {
              ...action.payload.pagination.listAnchor,
              ...state.data.pagination.listAnchor,
            },
          },
        },
      };
    },

    changeFormVisible(state, { payload }) {
      return { ...state, formVisible: payload };
    },
    saveFormTitle(state, { payload }) {
      return { ...state, formTitle: payload };
    },
    saveFormType(state, { payload }) {
      return { ...state, formType: payload };
    },
    saveFormID(state, { payload }) {
      return { ...state, formID: payload };
    },
    saveFormData(state, { payload }) {
      return { ...state, formData: payload };
    },
    changeSubmitting(state, { payload }) {
      return { ...state, submitting: payload };
    },
    saveTableChange(state, { payload }) {
      return { ...state, ...payload };
    }
  },
};

// import { getList } from '../services/voucher';

// export default {
//   namespace: 'vouchers',

//   state: {
//     data: {
//       list: [],
//       pagination: {
//         anchor: '',
//         listAnchor: {
//           1: ''
//         }
//       },
//     },
//   },

//   effects: {
//     *fetch({ payload }, { call, put }) {
//       const response = yield call(getList, payload);
//       // console.log('*fetch -> response %o', response);
//       if (response) {
//         yield put({
//           type: 'save',
//           payload: {
//             list: response.vouchers,
//             pagination: {
//               total: response.total,
//               anchor: response.anchor,
//               listAnchor: {
//                 [payload.current + 1]: response.anchor
//               }
//             }
//           },
//         });
//       }
//     },
//   },

//   reducers: {
//     save(state, action) {
//       return {
//         ...state,
//         data: {
//           ...state.data,
//           list: action.payload.list,
//           pagination: {
//             ...state.data.pagination,
//             anchor: action.payload.pagination.anchor,
//             total: action.payload.pagination.total,
//             listAnchor: {
//               ...action.payload.pagination.listAnchor,
//               ...state.data.pagination.listAnchor,
//             }
//           },
//         },
//       };
//     },
//   },
// };
